/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { useState, useEffect } from "react";

import React from "react";
import InputAdornment from "@material-ui/core/InputAdornment";
import TextField from "@material-ui/core/TextField";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Switch from "@material-ui/core/Switch";

import "react-perfect-scrollbar/dist/css/styles.css";
import PerfectScrollbar from "react-perfect-scrollbar";

import SerachIcon from "@material-ui/icons/Search";
import CloseIcon from "@material-ui/icons/Close";

import LinearProgress from "@material-ui/core/LinearProgress";
import Fade from "@material-ui/core/Grow";

import Masonry from "./MasonryLayout";

import DeskpadImage from "../../editor/image";

import axios from "axios";

import { useStoreon } from "storeon/react";

import t from "../../translations";

import { forceCheck } from "react-lazyload";

import Image from "comp/gallery/image";

const CancelSearchIcon = styled(CloseIcon)`
  width: 1.4em;
  height: 1.4em;
  transition: 0.2s ease all;
  color: #666;
  :hover {
    transform: scale(1.1);
    color: #444;
  }
`;

const SearchBar = styled(TextField)`
  margin-bottom: 8px;
  .clear {
    color: #9d9d9d;
    font-size: 18px;
    cursor: pointer;
    display: ${(props) => (props.value.length ? "block" : "none")};
  }
  > div {
    fieldset {
      border-width: 1px;
      border-color: white;
      border-radius: 5px;
      background: white;
    }
    :hover {
      fieldset {
        border-color: #a8bb43 !important;
      }
    }
    input {
      z-index: 1;
      color: black;
      padding: 9px 14px;
      padding-top: 6px;
      padding-left: 0px;
      font-size: 19px;
    }
  }

  .focused fieldset {
    border-width: 2px !important;
    border-color: #a8bb43 !important;
  }
  > div > div {
    z-index: 1;
    color: #9d9d9d;
    > svg {
      width: 1.5em;
      height: 1.5em;
      z-index: 1;
    }
  }
  @media screen and (max-width: 480px) {
    margin-bottom: 0px;
    > div {
      input {
        z-index: 1;
        color: black;
        padding: 5px 14px;
        padding-top: 5px;
        padding-left: 0px;
        font-size: 16px;
      }
    }
    > div > div {
      z-index: 1;
      color: #9d9d9d;
      > svg {
        width: 1em;
        height: 1em;
        z-index: 1;
      }
    }
  }
`;

const CategoryWrap = styled.div`
  color: #eee;
  cursor: pointer;
  height: 110px;
  padding: 5px;
  .title {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 3px 2px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    width: 100%;
  }
  :hover {
    background: #555555;
  }
  .preview {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    > img {
      max-width: 24%;
      object-fit: cover;
      height: 70px;
    }
  }
  @media screen and (max-width: 480px) {
    .title {
      margin: 0;
    }
  }
`;

const Category = (props) => {
  const { onCategorySelected } = props;
  const { name, files } = props.category;
  return (
    <CategoryWrap
      onClick={(_) => {
        onCategorySelected(name);
      }}
    >
      <div className="title">
        <div>{name}</div>
        <div>{t.all} ></div>
      </div>
      <div className="preview">
        {files.slice(0, 4).map((file) => {
          return <img src={file.preview} key={file.id} alt={name} />;
        })}
      </div>
    </CategoryWrap>
  );
};

const Gallery = (props) => {
  let scrollRef;
  const [images, setImages] = useState([]);

  const [category, setCategory] = useState("");
  const [isHighQuality, setIsHighQuality] = useState(true);

  const [categories, setCategories] = useState(
    window.dpe_categories ?? { photo: [], vector: [] }
  );

  const [page, setPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [type, setType] = useState(0);

  const { dispatch, canvas } = useStoreon("canvas");

  const getImages = (cat, pageToLoad = 1, type = 0, isHQ = false) => {
    if (isLoading || !cat) {
      return false;
    }
    const imageType = {
      // 0: "all",
      0: "photo",
      1: "vector",
    };
    window._paq?.push([
      "trackEvent",
      "Gallery",
      "Category selected",
      `${category} - ${imageType[type]}`,
    ]);
    setIsLoading(true);
    if (pageToLoad === 1) {
      scrollRef._container.scrollTop = 0;
    }
    const urlEncodedCat = encodeURIComponent(cat);

    const mmToPixel = (mm) => {
      const mmInInch = 1 / 25.4; //inch is 2.54mm
      const minDPI = canvas.settings.minDPI ? canvas.settings.minDPI : 100;
      return mm * minDPI * mmInInch;
    };
    let HQrequest = "";
    if (isHQ && type !== 1) {
      const w = mmToPixel(canvas.cutW + 6);
      const h = mmToPixel(canvas.cutH + 6);
      HQrequest = `&minWidth=${w.toFixed(0)}&minHeight=${h.toFixed(0)}`;
    }
    axios
      .get(
        `/wp-json/dpe/v1/pixabay?cat=${urlEncodedCat}&page=${pageToLoad}&type=${imageType[type]}${HQrequest}`
      )
      .then((resp) => {
        if (!resp.data.files) {
          console.error("Recived wrong data format", resp);
          setIsLoading(false);
          return;
        }
        if (pageToLoad === 1) {
          setImages(resp.data.files);
        } else {
          setImages([...images, ...resp.data.files]);
        }
        setPage(pageToLoad + 1);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Loading category failed", err);
        setIsLoading(false);
      });
  };

  const getCategories = () => {
    axios
      .get(`/wp-json/dpe/v1/pixabay/category`)
      .then((resp) => {
        if (!resp.data.categories) {
          console.error("Recived wrong data format for cats", resp.data);
          return;
        }
        setCategories(resp.data.categories);
        window.dpe_categories = resp.data.categories;
      })
      .catch((err) => {
        console.error("Loading cats failed", err);
        setIsLoading(false);
      });
  };

  const cacheImage = (image) => {
    const imgToLoad = image.original[0];
    const imgPlaceholder = image.large[0];
    const imageID = image.id;
    //Add and remove to pool, to prevent rendering preview before server loaded all images
    dispatch("cachePool/add", imageID);
    axios
      .post("/wp-json/dpe/v1/gallery/external", { url: imgToLoad })
      .then((resp) => {
        console.info("External image upload", resp.data);
        if (!resp.data.image) {
          console.error("External image upload failed", resp.data);
          return;
        }
        dispatch("cachePool/remove", imageID);
        const { image } = resp.data;
        canvas
          .getObjects()
          .filter((obj) => obj.src === imgPlaceholder)
          .forEach((obj) => {
            obj.hash = image.hash;
            obj.cachedSrc = image.sizes.large.file;
            obj.src = image.sizes.large.file;
            obj.thumb = image.sizes.thumb.file;
          });
      })
      .catch((err) => {
        console.error("Server loading external image failed", err);
      });
  };

  //TODO: make upload and gallery image same data structure
  const addImageToCanvas = (image, placeInside = false) => {
    const placeholder = image.id ? image.thumb[0] : image.sizes.thumb.file;
    const url = image.id ? image.large[0] : image.sizes.large.file;
    const isVector = image.isVector ? true : false;
    const width = image.id ? image.size.w : image.sizes.original.width;
    const height = image.id ? image.size.h : image.sizes.original.height;
    const hash = image.hash;
    !image.hash && cacheImage(image);
    new DeskpadImage(url).loadOnCanvas(
      canvas,
      { width, height, isVector, hash },
      placeholder,
      true,
      placeInside
    );
    const imageType = image.isVector ? "Vector" : "Rastr raster";
    window._paq?.push(["trackEvent", "Gallery", "Image added", imageType]);
  };

  useEffect(() => {
    if (!window.dpe_categories) {
      getCategories();
    }
  }, []);

  useEffect(() => {
    getImages(category, 1, type, isHighQuality);
    // eslint-disable-next-line
  }, [isHighQuality]);

  const handleChange = (e) => {
    setCategory(e.target.value);
  };

  const handleTypeChange = (e, val) => {
    getImages(category, 1, val, isHighQuality);
    setType(val);
  };

  const handleCategorySelection = (cat) => {
    setCategory(cat);
    getImages(cat, 1, type, isHighQuality);
  };

  useEffect(() => {
    const handleImageDrop = (e) => {
      const { dataTransfer } = e.e;
      if (dataTransfer) {
        const image = JSON.parse(dataTransfer.getData("text"));
        const target = canvas
          .getObjects()
          .find(
            (obj) =>
              obj.mask &&
              obj.containsPoint(canvas.getPointer(e.e), null, true, true)
          );
        if (target && target.mask) {
          target.absolutePositioned = true;

          const placeholder = image.id
            ? image.thumb[0]
            : image.sizes.thumb.file;
          const url = image.id ? image.large[0] : image.sizes.large.file;
          !image.hash && cacheImage(image);
          const width = image.id ? image.size.w : image.sizes.original.width;
          const height = image.id ? image.size.h : image.sizes.original.height;
          new DeskpadImage().addToCanvas(canvas, {
            fitTo: target,
            url,
            hash: image.hash,
            placeholder,
            width,
            height,
          });
          return;
        }
        console.info("target", e.target);
        console.info(image);
        addImageToCanvas(image, true);
      }
    };
    if (canvas) {
      canvas?.on("drop",  handleImageDrop);
    }
    return () => {
      canvas?.off("drop", handleImageDrop);
    };
  }, [canvas]);

  const categoriesToDisplay = type ? categories.vector : categories.photo;

  return (
    <React.Fragment>
      <Fade in={isLoading} unmountOnExit>
        <LinearProgress
          color="secondary"
          css={css`
            position: absolute;
            top: 0px;
            left: 0px;
            width: 100%;
            height: 2px;
          `}
        />
      </Fade>
      <SearchBar
        value={category}
        variant="outlined"
        fullWidth
        onChange={handleChange}
        onKeyPress={(ev) => {
          if (ev.key === "Enter") {
            getImages(category, 1, type, isHighQuality);
            ev.preventDefault();
          }
        }}
        InputProps={{
          classes: {
            focused: "focused",
          },
          startAdornment: (
            <InputAdornment position="start">
              <SerachIcon style={{ color: "#666" }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              <div
                className="clear"
                onClick={(e) => {
                  setImages([]);
                  setCategory("");
                  setPage(1);
                  scrollRef._container.scrollTop = 0;
                }}
              >
                <CancelSearchIcon />
              </div>
            </InputAdornment>
          ),
        }}
      />
      <Tabs value={type} onChange={handleTypeChange}>
        <Tab label={t.photos} />
        <Tab label={t.graphics} />
      </Tabs>
      <PerfectScrollbar
        ref={(ref) => {
          scrollRef = ref;
        }}
        onScrollY={(_) => {
          forceCheck();
        }}
        onYReachEnd={(e) => {
          if (!scrollRef) return;
          if (!images.length) return;
          getImages(category, page, type);
        }}
        style={{ height: "calc(100% - 78px)" }}
      >
        {category && type !== 1 && (
          <Typography style={{ color: "white", fontSize: 15 }}>
            <Switch
              checked={isHighQuality}
              onClick={(_) => setIsHighQuality((isHQ) => !isHQ)}
              css={css`
                @media screen and (max-width: 480px) {
                  > span:first-of-type {
                    height: 35px;
                  }
                }
              `}
            />
            {t.onlyHighQuality}
          </Typography>
        )}
        {!images.length && !category && (
          <div>
            {categoriesToDisplay.map((cat) => {
              return (
                <Category
                  category={cat}
                  key={cat.name}
                  keyForLayout={cat.name}
                  onCategorySelected={handleCategorySelection}
                />
              );
            })}
          </div>
        )}
        <Masonry columns={2} gap={1}>
          {images.map((i) => {
            return (
              <Image
                image={i}
                key={i.id}
                keyForLayout={i.id}
                onClick={addImageToCanvas}
              />
            );
          })}
        </Masonry>
      </PerfectScrollbar>
    </React.Fragment>
  );
};

export default Gallery;
